import { createFileRoute } from '@tanstack/react-router';

import { NotFoundPageContainer } from '../components/app/NotFound';

export const Route = createFileRoute('/404')({
  staticData: {
    secure: false,
  },
  component: NotFoundPageContainer,
});
